<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-address-card"></i> <ng-container i18n>Billing Address</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div [formGroup]="form">
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field class="mat-block">
          <input
            matInput
            placeholder="Billing From (default to account name if not provided)"
            type="text"
            formControlName="name"
          />
          <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('allSpaces')">
            Name cannot be spaces alone.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input matInput placeholder="Address" i18n-placeholder type="text" formControlName="address" required />
          <mat-error *ngIf="form.get('address').touched && form.get('address').hasError('allSpaces')" i18n>
            Address cannot be spaces alone.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input matInput placeholder="City" i18n-placeholder type="text" formControlName="city" required />
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            matInput
            placeholder="State / Province / Region"
            i18n-placeholder
            type="text"
            formControlName="state"
            required
          />
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            matInput
            placeholder="Postal Code"
            i18n-placeholder
            type="text"
            formControlName="postal_code"
            required
          />
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <ng-select
          [items]="countryList"
          [selectOnTab]="true"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          formControlName="country_code"
          placeholder="Country"
          i18n-placeholder
          class="mat-block"
          appendTo="body"
          required
        >
        </ng-select>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> <ng-container i18n>cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
